import React from "react";
import { Button } from "react-bootstrap";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MoreVertIcon from "@material-ui/icons/MoreVert";

export default function Options(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [buttonType, setButtonType] = React.useState(false);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDownload = () => {
    props.parentDownload();
    setAnchorEl(null);
  };

  const handleDelete = () => {
    props.parentDelete();
    setAnchorEl(null);
  };

  const handleClassStatus = () => {
    if (buttonType === true) {
      setButtonType(false);
      props.parentDisable();
    } else {
      setButtonType(true);
      props.parentDisable();
    }
    setAnchorEl(null);
  };

  let buttoncl;
  if (buttonType === false)
    buttoncl = (
      <MenuItem
        style={{ background: "#475A82", color: "#C2C0BD", marginTop: '-8px' }}
        onClick={handleClassStatus}
      >
        Disble Class
      </MenuItem>
    );
  else
    buttoncl = (
      <MenuItem
        style={{ background: "#475A82", color: "#C2C0BD", marginTop: '-8px' }}
        onClick={handleClassStatus}
      >
        Enable Class
      </MenuItem>
    );

  return (
    <div style={{ marginTop: "2.5px" }}>
      <Button
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
        style={{
          padding: "0px",
          border: "0px",
          backgroundColor: "#2E3A53",
          color: "#17D9AA",
          outline: "none"
        }}
      >
        <MoreVertIcon />
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {buttoncl}
        <MenuItem
          style={{ background: "#475A82", color: "#C2C0BD" }}
          onClick={handleDelete}
        >
          Delete Class
        </MenuItem>
        <MenuItem
          style={{ background: "#475A82", color: "#C2C0BD", marginBottom: '-8px' }}
          onClick={handleDownload}
        >
          Download Sample
        </MenuItem>
      </Menu>
    </div>
  );
}
